import { render, staticRenderFns } from "./issues-dialog.vue?vue&type=template&id=4cc0d1d4&"
import script from "./issues-dialog.vue?vue&type=script&lang=js&"
export * from "./issues-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports